export const CONTROLLER_TOAST_MESSAGE_TYPE = "controller-toast";
//# sourceMappingURL=types.js.map